import NotFoundView from '@/components/error/404.vue'
import Agentmanagement from '@/components/view/Agentmanagement/main.vue'
import Account from '@/components/view/allbots/Account'
import Billing from '@/components/view/billing/Billing'
import Upgrade from '@/components/view/billing/Upgrade'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Chat from '@/components/view/chat/Chat'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'
import Dashboard from '@/components/view/dashboard/Dashboard'
import Export from '@/components/view/Export/Export'
import GetCurrentLocation from '@/components/view/GetCurrentLocation.vue'
import Setup from '@/components/view/getstarted/Setup'
import Comment from '@/components/view/intent/CommentToInbox'
import Conversation from '@/components/view/intent/Conversation'
import Training from '@/components/view/intent/Training'
import Live from '@/components/view/live/Main'
import LivechatView from '@/components/view/livechat/LivechatView'
import PBlog from '@/components/view/partner/Blog'
import PCustomer from '@/components/view/partner/Customer'
import PProfile from '@/components/view/partner/Profile'
import PRedeemCode from '@/components/view/partner/RedeemCode'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import BbqUnansweredMsgInfo from '@/components/view/template/Bbq/UnansweredMsgInfo.vue'
import CityFreshAgentmanagement from '@/components/view/template/cityfresh/agentmanagement/CityFreshAgentmanagement.vue'
import CityFreshManagement from '@/components/view/template/cityfresh/management/CityFreshManagement.vue'
import CityFreshProfile from '@/components/view/template/cityfresh/profile/CityFreshprofile.vue'
import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'
import FoodguruCustomer from '@/components/view/template/foodguru/main.vue'
import HopinnHrHumanResource from '@/components/view/template/HopinnHr/HumanResource.vue'
import KingkitchenAdminmenu from '@/components/view/template/kingKitchen/adminMenu/main.vue'
import KingkitchenMember from '@/components/view/template/kingKitchen/member/main.vue'
import LamyManagement from '@/components/view/template/lamy/main.vue'
import LamyMembership from '@/components/view/template/lamy/Membership.vue'
import LamyProductAndBranch from '@/components/view/template/lamy/ProductAndBranch/main.vue'
import LamyPurchaseBehavior from '@/components/view/template/lamy/PurchaseBehavior/main.vue'
import NongtungjaiAlcoholHistory from '@/components/view/template/NongTungJai/AlcoholHistory.vue'
import NongtungjaiPatientHistory from '@/components/view/template/NongTungJai/PatientHistory.vue'
import NongtungjaiPatientHistoryDetails from '@/components/view/template/NongTungJai/PatientHistoryDetails.vue'
import PowerbuyAnalytics from '@/components/view/template/powerbuy/Analytics/main.vue'
import PowerbuyBranchManagement from '@/components/view/template/powerbuy/BranchManagement/BranchManagement.vue'
import PowerbuySubBranchManagement from '@/components/view/template/powerbuy/BranchManagement/SubBranchManagement.vue'

import PowerbuyFacebookPostManager from '@/components/view/template/powerbuy/FacebookPostManager/main.vue'
import PowerbuyFacebookShearPostManager from '@/components/view/template/powerbuy/FacebookShearPostManager/main.vue'
import PowerbuyInstagramPostManager from '@/components/view/template/powerbuy/InstagramManager/main.vue'
import PowerbuyLineBroadcast from '@/components/view/template/powerbuy/LineBroadcast/main.vue'
import PowerbuyManagement from '@/components/view/template/powerbuy/Management/main.vue'
import RunnerManager from '@/components/view/template/runkan/main.vue'
import SahapanReward from '@/components/view/template/sahapan/main.vue'
import SecapMaintenanceServiceBooking from '@/components/view/template/secap/MaintenanceServiceBooking.vue'
import SecapServiceCenterManagement from '@/components/view/template/secap/ServiceCenterManagement.vue'
import TDagentmanagement from '@/components/view/template/tdtawandang/agentmanagement/main.vue'
import TDmanagement from '@/components/view/template/tdtawandang/management/main.vue'
import TDNotificationSetting from '@/components/view/template/tdtawandang/notificationsetting/main.vue'
import Template from '@/components/view/template/template'
import Questionaire from '@/components/view/template/tero/main.vue'
import Ticket from '@/components/view/template/ticket/main.vue'
import RabbitReplyFBPost from '@/components/view/template/ticket/RabbitReplyFBPost/main.vue'
import ToaAgentmanagement from '@/components/view/template/toa/agentmanagement/main.vue'
import ToaManagement from '@/components/view/template/toa/management/main.vue'
import ToaCampaign from '@/components/view/template/toaecoupon/Campaign'
import ToaMember from '@/components/view/template/toaecoupon/Member'
import TrueidSystemMaintenance from '@/components/view/template/trueid/SystemMaintenance.vue'
import YasaleAcAdminMenu from '@/components/view/template/YasaleAc/AdminMenu.vue'
import Ticket2agentmanagement from '@/components/view/ticket2/agentmanagement/main.vue'
import Ticket2management from '@/components/view/ticket2/management/main.vue'
import Productandbranch from '@/components/view/ticket2/productandbranch/main.vue'
import Ticket2profile from '@/components/view/ticket2/profile/main.vue'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'

import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connectline',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/login/ConnectLine.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Prepare.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: function (resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'login',
        name: 'login',
        component: function (resolve) {
          require(['@/components/login/Login.vue'], resolve)
        }
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: function (resolve) {
          require(['@/components/login/Chat2Pay.vue'], resolve)
        },
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'getcurrentlocation',
        name: 'getcurrentlocation',
        component: GetCurrentLocation
      },
      {
        path: 'ticket',
        name: 'ticket',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: Billing,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'productandbranch',
        name: 'productandbranch',
        component: Productandbranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Product and branch'
        }
      },
      {
        path: 'ticket2profile',
        name: 'ticket2profile',
        component: Ticket2profile,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'ticket2management',
        name: 'ticket2management',
        component: Ticket2management,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'ticket2agentmanagement',
        name: 'ticket2agentmanagement',
        component: Ticket2agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'tdmanagement',
        name: 'tdmanagement',
        component: TDmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'tdagentmanagement',
        name: 'tdagentmanagement',
        component: TDagentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'tdnotificationsetting',
        name: 'tdnotificationsetting',
        component: TDNotificationSetting,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat setting'
        }
      },
      {
        path: 'yasale-ac-admin-menu',
        name: 'YasaleAcAdminMenu',
        component: YasaleAcAdminMenu,
        beforeEnter: guardRoute,
        meta: {
          title: 'Admin Menu'
        }
      },
      {
        path: 'nongtungjai',
        component: {
          name: 'nongtungjai',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'patient-history',
            name: 'patient-history',
            component: NongtungjaiPatientHistory,
            beforeEnter: guardRoute,
            meta: {
              title: 'Patient History'
            }
          },
          {
            path: 'patient-history/:id',
            name: 'patient-history-details',
            component: NongtungjaiPatientHistoryDetails,
            beforeEnter: guardRoute,
            meta: {
              title: 'Patient History Details'
            }
          },
          {
            path: 'alcohol-history',
            name: 'alcohol-history',
            component: NongtungjaiAlcoholHistory,
            beforeEnter: guardRoute,
            meta: {
              title: 'Alcohol History'
            }
          }
        ]
      },

      // {
      //   path: 'nongtungjai/patient-history',
      //   name: 'NongtungjaiPatientHistory',
      //   component: NongtungjaiPatientHistory,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'Patient History'
      //   }
      // },
      // {
      //   path: 'nongtungjai/patient-history-details',
      //   name: 'NongtungjaiPatientHistoryDetails',
      //   component: NongtungjaiPatientHistoryDetails,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'Patient History Details'
      //   }
      // },
      // {
      //   path: 'nongtungjai/alcohol-history',
      //   name: 'NongtungjaiAlcoholHistory',
      //   component: NongtungjaiAlcoholHistory,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'Alcohol History'
      //   }
      // },
      {
        path: 'toaagentmanagement',
        name: 'toaagentmanagement',
        component: ToaAgentmanagement
      },
      {
        path: 'toamanagement',
        name: 'toamanagement',
        component: ToaManagement
      },
      {
        path: 'cityfreshmanagement',
        name: 'cityfreshmanagement',
        component: CityFreshManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket management'
        }
      },
      {
        path: 'cityfreshagentmanagement',
        name: 'cityfreshagentmanagement',
        component: CityFreshAgentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'cityfreshprofile',
        name: 'cityfreshprofile',
        component: CityFreshProfile,
        beforeEnter: guardRoute,
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'rabbitreplyfbpost',
        name: 'rabbitreplyfbpost',
        component: RabbitReplyFBPost,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply Facebook Post'
        }
      },
      {
        path: 'secap-service-center-management',
        name: 'SecapServiceCenterManagement',
        component: SecapServiceCenterManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Service Center Management'
        }
      },
      {
        path: 'secap-maintenance-service-booking',
        name: 'SecapMaintenanceServiceBooking',
        component: SecapMaintenanceServiceBooking,
        beforeEnter: guardRoute,
        meta: {
          title: 'Maintenance Service Booking'
        }
      },
      {
        path: 'hopinnhr-human-resource',
        name: 'HopinnHrHumanResource',
        component: HopinnHrHumanResource,
        beforeEnter: guardRoute,
        meta: {
          title: 'Human Resource'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        path: 'RedeemCode',
        name: 'RedeemCode',
        component: RedeemCode,
        beforeEnter: guardRoute,
        meta: {
          title: 'Redeem Code'
        }
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live'
        }
      },
      {
        path: 'RewardManager',
        name: 'RewardManager',
        component: SahapanReward,
        beforeEnter: guardRoute,
        meta: {
          title: 'Sahapan Reward'
        }
      },
      {
        path: 'Questionaire',
        name: 'Questionaire',
        component: Questionaire,
        beforeEnter: guardRoute,
        meta: {
          title: 'Questionaire'
        }
      },
      {
        path: 'agentmanagement',
        name: 'AgentManagement',
        component: Agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },
      {
        path: 'PowerbuyManagement',
        name: 'PowerbuyManagement',
        component: PowerbuyManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Management'
        }
      },
      {
        path: 'PowerbuyAnalytics',
        name: 'PowerbuyAnalytics',
        component: PowerbuyAnalytics,
        beforeEnter: guardRoute,
        meta: {
          title: 'Analytics'
        }
      },
      {
        path: 'PowerbuyLineBroadcast',
        name: 'PowerbuyLineBroadcast',
        component: PowerbuyLineBroadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Line Broadcast'
        }
      },
      {
        path: 'PowerbuyFacebookPostManager',
        name: 'PowerbuyFacebookPostManager',
        component: PowerbuyFacebookPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'PowerbuyInstagramPostManager',
        name: 'PowerbuyInstagramPostManager',
        component: PowerbuyInstagramPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'PowerbuyFacebookShearPostManager',
        name: 'PowerbuyFacebookShearPostManager',
        component: PowerbuyFacebookShearPostManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Post Manager'
        }
      },
      {
        path: 'powerbuy',
        component: {
          name: 'powerbuy',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'branch-management',
            name: 'branch-management',
            component: PowerbuyBranchManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Branch Management'
            }
          },
          {
            path: 'branch-management/view/:id',
            name: 'sub-branch-management',
            component: PowerbuySubBranchManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'Sub Branch Management'
            }
          }
        ]
      },
      {
        path: 'bbq',
        component: {
          name: 'bbq',
          template: '<router-view></router-view>'
        },
        beforeEnter: guardRoute,
        children: [
          {
            path: 'unanswered-message-info',
            name: 'unanswered-message-info',
            component: BbqUnansweredMsgInfo,
            beforeEnter: guardRoute,
            meta: {
              title: 'Unanswered Message Info'
            }
          }
        ]
      },
      {
        path: 'runnerrunkan',
        name: 'Runner Manager',
        component: RunnerManager,
        beforeEnter: guardRoute,
        meta: {
          title: 'Runner Manager'
        }
      },
      {
        path: 'KingkitchenMember',
        name: 'KingkitchenMember',
        component: KingkitchenMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Member'
        }
      },
      {
        path: 'KingkitchenAdminMenu',
        name: 'KingkitchenAdminmenu',
        component: KingkitchenAdminmenu,
        beforeEnter: guardRoute,
        meta: {
          title: 'Adminmenu'
        }
      },
      {
        path: 'FoodguruCustomer',
        name: 'FoodguruCustomer',
        component: FoodguruCustomer,
        beforeEnter: guardRoute,
        meta: {
          title: 'Customer'
        }
      },
      {
        path: 'LamyManagement',
        name: 'LamyManagement',
        component: LamyManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'News/Promotions, Gift'
        }
      },
      {
        path: 'Membership',
        name: 'Membership',
        component: LamyMembership,
        beforeEnter: guardRoute,
        meta: {
          title: 'Membership'
        }
      },
      {
        path: 'PurchaseBehavior',
        name: 'PurchaseBehavior',
        component: LamyPurchaseBehavior,
        beforeEnter: guardRoute,
        meta: {
          title: 'Purchase Behavior'
        }
      },
      {
        path: 'LamyProductAndBranch',
        name: 'LamyProductAndBranch',
        component: LamyProductAndBranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Product & Branch'
        }
      },
      {
        path: 'toamember',
        name: 'toamember',
        component: ToaMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Member'
        }
      },
      {
        path: 'toacampaign',
        name: 'toacampaign',
        component: ToaCampaign,
        beforeEnter: guardRoute,
        meta: {
          title: 'Campaign'
        }
      },
      {
        path: 'trueid',
        name: 'trueid',
        beforeEnter: guardRoute,
        component: {
          name: 'trueid',
          template: '<router-view />'
        },
        children: [
          {
            path: 'system-maintenance',
            name: 'system-maintenance',
            component: TrueidSystemMaintenance,
            beforeEnter: guardRoute,
            meta: {
              title: 'System maintenance'
            }
          },

          {
            path: '',
            redirect: 'system-maintenance'
          }
        ]
      },

      {
        path: 'partner',
        component: {
          name: 'partner',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'profile'
          },
          {
            path: 'profile',
            name: 'profile',
            component: PProfile,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Profile'
            }
          },
          {
            path: 'blog',
            name: 'blog',
            component: PBlog,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Blog'
            }
          },
          {
            path: 'redeemcode',
            name: 'redeemcode',
            component: PRedeemCode,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Redeem Code'
            }
          },
          {
            path: 'customer',
            name: 'customer',
            component: PCustomer,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Customer'
            }
          }
        ]
      },
      {
        path: 'export',
        name: 'export',
        component: Export,
        beforeEnter: guardRoute,
        meta: {
          title: 'Export'
        }
      },

      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (to.name == 'dashboard' && to.query && to.query.tab == 'ceemeagain') {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { tab: 'ceemeagain' }
      })
      return
    }
  }
  var query = { ...to.query }
  query.redirect = to.fullPath

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardPartnerRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/nigol',
      query: { redirect: to.fullPath, utm_source: to.query.utm_source }
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  }
}

function checkTokenStatus(next) {
  var vm = router.app
  if (
    store.state.selectedBot &&
    Object.keys(store.state.selectedBot).length &&
    store.state.selectedBot.hasOwnProperty('statustoken') &&
    !store.state.selectedBot.statustoken
  ) {
    // Swal({
    //   icon: 'error',
    //   width: 650,
    //   allowOutsideClick: false,
    //   confirmButtonColor: '#d33',
    //   title: vm.$t('Hey! Your chatbot has connection error.'),
    //   html: vm.$t('Admin page please log into the zwiz system') + ' <a href="https://cms.zwiz.ai/en/login">(https://cms.zwiz.ai/en/login)</a> ' + vm.$t('again.')
    // }).then(() => {
    //   if (store.getters.isFacebook) {
    //     logout(next)
    //   }
    // })
  }
}

function logout(next) {
  var isFacebook = store.getters.isFacebook
  store.dispatch('logout', null).then()
  if (isFacebook) {
    next({
      path: '/' + store.getters.currentLang + '/nigol'
    })
  } else {
    next({
      path: '/' + store.getters.currentLang + '/nigol'
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js